import { createContext, useContext } from "react";

export interface TaskDocumentRef {
  documentId: number;
  fileName: string;
}

interface SubtaskActionsContextValue {
  toggleSubtask: (subtaskId: number, completed: boolean) => Promise<void>;
  updateSubtaskValue: (
    subtaskId: number,
    value: string | boolean,
    currentlyCompleted: boolean,
  ) => Promise<void>;
  stageDocument: (file: File, purpose: string) => Promise<number>;
  deleteUploadedDocument: (documentId: number) => Promise<void>;
  detachDocument: (documentId: number) => Promise<void>;
  /** Active (non-staged) documents already attached to this task. */
  taskDocuments: TaskDocumentRef[];
  /** Staged (uploaded but not yet submitted) documents for this task. */
  stagedTaskDocuments: TaskDocumentRef[];
}

const noop = (): Promise<void> => Promise.resolve();
const noopStage = (): Promise<number> => Promise.resolve(0);

const SubtaskActionsContext = createContext<SubtaskActionsContextValue>({
  toggleSubtask: noop,
  updateSubtaskValue: noop,
  stageDocument: noopStage,
  deleteUploadedDocument: noop,
  detachDocument: noop,
  taskDocuments: [],
  stagedTaskDocuments: [],
});

export const SubtaskActionsProvider = SubtaskActionsContext.Provider;

export function useSubtaskActionsContext(): SubtaskActionsContextValue {
  return useContext(SubtaskActionsContext);
}
